import { CircularProgress, Stack } from '@mui/material';
import { UserSettings } from '@silbo/core';
import { HospitalBedroomIcon, palette } from '@silbo/ui';
import { getProgressValue } from '../utils/get-progress-value';
import { getOccupancyLevelColor } from '../utils/occupancy-levels-colors';

const StatisticIcon = ({ rate, config }: { rate: number; config: UserSettings }) => {
  const occupancyColor = getOccupancyLevelColor(rate, config);
  return (
    <Stack position="relative" justifyContent="center" alignItems="center" width={48} height={48}>
      <HospitalBedroomIcon
        sx={{
          backgroundColor: occupancyColor.background,
          color: occupancyColor.main,
          borderRadius: '50%',
          padding: 1.5,
          height: 36,
          boxSizing: 'border-box',
          width: 36,
        }}
      />
      <CircularProgress
        size={48}
        sx={{ transitionDuration: 0.8, position: 'absolute', color: occupancyColor.main || palette.default.main }}
        variant="determinate"
        value={getProgressValue(rate)}
      />
    </Stack>
  );
};

export default StatisticIcon;
